'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloseButton = function (_PureComponent) {
  _inherits(CloseButton, _PureComponent);

  function CloseButton() {
    _classCallCheck(this, CloseButton);

    return _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).apply(this, arguments));
  }

  _createClass(CloseButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClick = _props.onClick,
          className = _props.className;

      return _react2.default.createElement(
        'button',
        { className: 'CloseButton ' + className, onClick: onClick },
        _react2.default.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            className: 'CloseButton-icon ' + className + '-icon',
            viewBox: '0 0 13 13',
            height: '13px',
            width: '13px'
          },
          _react2.default.createElement('path', { d: 'M12.712.298a.982.982 0 0 0-1.39 0L6.5 5.11 1.679.288a.982.982 0 1 0-1.39 1.39L5.108 6.5.29 11.321a.982.982 0 1 0 1.39 1.39L6.5 7.892l4.821 4.82a.982.982 0 1 0 1.39-1.39L7.892 6.5l4.82-4.821a.988.988 0 0 0 0-1.38z' })
        )
      );
    }
  }]);

  return CloseButton;
}(_react.PureComponent);

CloseButton.propTypes = {
  className: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired
};

exports.default = CloseButton;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/CloseButton.js
// module id = 151
// module chunks = 0